"use client"

import styles from "../../styles/shared-module-css/ProgressBar.module.css"

const ProgressBar = ({
  percentage = 0,
  backgroundColor = "#e5e7eb",
  height = "10px",
  className = "",
  showPercentage = true,
}) => (
  <div className={`${styles.progress_container} ${className}`}>
    <div className={styles.progress_bar} style={{ backgroundColor, height }}>
      <div
        className={styles.progress_fill}
        style={{
          width: `${Math.min(Math.max(percentage, 0), 100)}%`,
          
        }}
      />
    </div>
    {showPercentage && <span className={styles.percentage_text}>{percentage}%</span>}
  </div>
)

export default ProgressBar
